import { Helpers } from './Helpers';
import { WithholdingRateEnum } from '../models/common/Enums';
import { GetInvoiceByIdResponseInvoiceDetail, GetInvoiceByIdResponseInvoiceDetailWithholding } from '../models/response/invoice/GetInvoiceByIdResponse';

/**
 * Fatura tevkifat hesabı (06.10.2026):
 * - Alt limit kontrolü faturanın TEVKİFAT ÖNCESİ brüt toplamına (KDV hariç toplam + KDV) bakar; satır satır değil.
 * - Toplam, tevkifat tanımındaki alt limite (KDV dahil) eşit ya da büyükse tevkifat oranı olan BÜTÜN satırlara uygulanır.
 * - Tutar değişmedi: satır KDV'sinin 2/10'u ya da 9/10'u.
 * Eskiden yalnız düzenlenen satır, diğer satırların tevkifat düşülmüş toplamlarıyla kontrol ediliyordu; satır eklenip
 * silinince önceki satırlar güncellenmiyordu.
 */

type Satir = Pick<GetInvoiceByIdResponseInvoiceDetail, 'totalWithoutTaxPrice' | 'taxPrice'>;

/** Faturanın tevkifat öncesi brüt toplamı (KDV hariç + KDV). */
export const faturaBrutToplami = (satirlar: Satir[]) =>
    Helpers.sumOfNumbers(satirlar.map(x => Helpers.toNumber(x.totalWithoutTaxPrice) + Helpers.toNumber(x.taxPrice)));

/** Bir satırın tevkifat tutarı (4 hane, metin). Alt limit altında ya da müşteri tevkifata tabi değilse '0'. */
export const tevkifatTutari = (
    taxPrice: string | undefined,
    tevkifat: GetInvoiceByIdResponseInvoiceDetailWithholding | undefined,
    brutToplam: number,
    musteriTevkifatli: boolean
) => {
    if (!tevkifat || !musteriTevkifatli || brutToplam < (tevkifat.lowerLimitVatIncluded ?? 0))
        return '0';

    if (tevkifat.withholdingRateKey == WithholdingRateEnum._2_10)
        return ((Helpers.toNumber(taxPrice) / 10) * 2).toFixed(4);

    if (tevkifat.withholdingRateKey == WithholdingRateEnum._9_10)
        return ((Helpers.toNumber(taxPrice) / 10) * 9).toFixed(4);

    return '0';
}

/**
 * Ekranda görünen oran: tevkifat hesaplanmıyorsa (alt limit altı, müşteri tabi değil) boş. Tanım satırda kalır; satır
 * eklenip limit aşılınca yeniden hesap için gerekir.
 */
export const gorunenTevkifatOrani = (oran: string | undefined, tevkifatTutari: string | undefined) =>
    Helpers.toNumber(tevkifatTutari) > 0 ? (oran ?? '') : '';

/**
 * Satır eklendi / güncellendi / silindi: tevkifat tanımı olan bütün satırların tevkifatını ve toplamını
 * faturanın brüt toplamına göre yeniden hesaplar. Tanımı olmayan satırlar (ör. Yurtiçi) olduğu gibi kalır.
 */
export const tevkifatlariYenidenHesapla = (satirlar: GetInvoiceByIdResponseInvoiceDetail[], musteriTevkifatli: boolean) => {
    const brut = faturaBrutToplami(satirlar);

    return satirlar.map(x => {
        if (!x.withholding)
            return x;

        const tutar = tevkifatTutari(x.taxPrice, x.withholding, brut, musteriTevkifatli);

        return {
            ...x,
            withholdingPrice: tutar,
            totalPrice: (Helpers.toNumber(x.totalWithoutTaxPrice) + Helpers.toNumber(x.taxPrice) - Helpers.toNumber(tutar)).toFixed(4),
        };
    });
}
